import { cn } from "@roman/shared/utils";
import type React from "react";

interface ChoiceCardGraphProps {
  id: string;
  name: string;
  probability: number;
  commentCount?: number;
  color: string;
  onClick: (id: string) => void;
  className?: string;
}

export const ChoiceCardGraph: React.FC<ChoiceCardGraphProps> = ({
  id,
  name,
  probability,
  color,
  onClick,
  className,
}) => {
  return (
    <div
      className={cn(
        "text-sm grid grid-cols-[auto_1fr_auto] gap-2 items-center text-left rounded-sm cursor-pointer hover:bg-opacity-80 transition",
        className,
      )}
      onClick={() => onClick(id)}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
        <circle cx="4" cy="4" r="4" fill={color} />
      </svg>
      <div className="flex justify-between items-center w-full gap-1.5">
        <span className="text-[10px] leading-[140%] text-dark-gray font-normal">{name}</span>
        <span className="text-[10px] text-dark-gray font-bold">
          {probability * 100 >= 1
            ? Math.round(probability * 100) === 100
              ? "99"
              : Math.round(probability * 100)
            : "<1"}
          %
        </span>
      </div>
    </div>
  );
};
